export const Link = `
    <Link 
        color="default" // String: default , primary, hint
        href="#" // String: url, mailto, tel, #
        target="_self" // String: _self (by default), _blank, _parent, _top
        download={false} // Boolean: true, false (by default)
        size="md" // String: sm, md (by default), lg
        className="custom-class" // String
    >
    Link
    </Link>
`
